<div class="dialog-content flex-col w-100 justify-stretch items-stretch">
  <h2 mat-dialog-title>{{title}} '{{contextDescription}}'</h2>
  @if (busy) {
    <div class="overlay">
      <div class="center">
        <mat-spinner>
        </mat-spinner>
      </div>
    </div>
  }
  <mat-dialog-content>
    <div class="flex-column w-100 my-2" [formGroup]="uploadForm">
      @if (multiple) {
        <!-- several files: name and description per file, type and visibility below for all of them -->
        <div class="dud-files">
          @for (row of fileRows.controls; track row; let i = $index) {
            <div class="dud-file" [formGroup]="row">
              <mat-icon class="dud-file-icon">{{fileIcon(row.get('file')!.value)}}</mat-icon>
              <div class="dud-file-fields">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="dud-field">
                  <mat-label>Filename</mat-label>
                  <input matInput formControlName="filename" required>
                  @if (row.get('filename')!.hasError('required')) { <mat-error>Name is required</mat-error> }
                  @if (row.get('filename')!.hasError('minlength')) { <mat-error>At least 5 characters</mat-error> }
                </mat-form-field>
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="dud-field">
                  <mat-label>Description (optional)</mat-label>
                  <input matInput formControlName="description">
                </mat-form-field>
                @if (perFileType) {
                  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="dud-field">
                    <mat-label>Type</mat-label>
                    <mat-select formControlName="documentType" required>
                      @for (documentType of documentTypeArray; track documentType.id) {
                        <mat-option [value]="documentType">{{documentType.name}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
              </div>
              <button mat-icon-button type="button" (click)="removeFile(i)" matTooltip="Remove from this upload"><mat-icon>close</mat-icon></button>
            </div>
          }
        </div>
        <button mat-stroked-button type="button" class="w-100 my-3" (click)="filesInput.click()"><mat-icon>add</mat-icon>{{ fileRows.length ? 'Add more files' : 'Select files' }}</button>
        <input #filesInput hidden type="file" multiple (change)="onFilesChange($event)">
        @if (fileRows.length > 1) {
          <mat-checkbox color="primary" [checked]="perFileType" (change)="setPerFileType($event.checked)">Set the type per file</mat-checkbox>
        }
        @if (fileRows.length > 0 && !perFileType) {
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mt-3">
            <mat-label>{{ fileRows.length > 1 ? 'Type (all files)' : 'Type' }}</mat-label>
            <mat-select formControlName="documentType" required>
              @for (documentType of documentTypeArray; track documentType.id) {
                <mat-option [value]="documentType">{{documentType.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      }
      @if (!editMode && !multiple) {
        <div>
          <button mat-flat-button class="w-100 my-3" color="primary" (click)="fileInput.click()">Select File</button>
          <input #fileInput hidden type="file" required fileLimit="1" fileAccept=".pdf,.jpg,.JPG,.jpeg,.JPEG.png,.PNG" (change)="onFileChange($event)">
        </div>
      }
      @if (fileSelected && !multiple) {
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mt-3">
          <mat-label>Filename</mat-label>
          <input matInput formControlName="filename" required>
          @if (uploadForm.get('filename')!.errors?.['required']) {
            <mat-error>Name is required</mat-error>
          }
          @if (uploadForm.get('filename')!.hasError('minlength')) {
            <mat-error>Name isn't long enough, minimum of 5 characters</mat-error>
          }
        </mat-form-field>
        <mat-form-field  appearance="outline" subscriptSizing="dynamic" class="w-100 mt-3">
          <mat-label>Type</mat-label>
          <mat-select formControlName="documentType" required>
            @for (documentType of documentTypeArray; track documentType.id) {
              <mat-option [value]="documentType">
                {{documentType.name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
         <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mt-3">
          <mat-label>Description</mat-label>
          <input matInput formControlName="description">
        </mat-form-field>
      }
      @if (fileSelected && visibilitySelectionRequired) {
        <mat-form-field appearance="outline" class="w-100 mt-3">
          <mat-label>Visibility</mat-label>
          <mat-select formControlName="visibility"  required>
            @for (visibility of documentVisibilityList; track visibility.id) {
              <mat-option [value]="visibility">
                {{visibility.name}}
              </mat-option>
            }
          </mat-select>
          @if (uploadForm.get('visibility')?.errors?.required) {
            <mat-error>Visibility is required</mat-error>
          }
        </mat-form-field>
      }
      @if (fileSelected && showRoleSelection) {
        <!-- roles that see a not public (or user restricted) document besides super admins -->
        <div class="flex-col mt-2">
          <span class="text-sm fw-600">Also visible to</span>
          <mat-checkbox formControlName="visibleToClient" color="primary">Client</mat-checkbox>
          @if (isPublic) {
            <span class="text-muted text-sm">Public documents are visible to everyone.</span>
          }
        </div>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="flex-row space-between items-center w-100 mt-3">
      <button [disabled]="!canUpload" mat-flat-button class="w-49" color="primary" (click)="onConfirmClick()" tabindex="1" >{{confirmButtonText}}</button>
      <button mat-flat-button class="w-49" color="primary" (click)="onCancelClick()" >{{cancelButtonText}}</button>
    </div>
  </mat-dialog-actions>
</div>

